import React from 'react';
import { Link } from 'gatsby';

export default ({ pageContext: { allHints } }) => (
  <div style={{ padding: "20px" }}>
    <h1>{allHints.game} Hints</h1>
    <p style={{ color: "#999999", marginBottom: "24px" }}>
      Rooms are numbered on the vertical axis and assigned letters on the horizontal, where the starting room is{" "}
      {allHints.startingRoom}. There are hints for each puzzle that range from extremely vague to very specific, with
      the specificity increasing with each hint. Reveal as many as you need to get yourself unstuck. The very last hint
      in most cases is a video walkthrough.
    </p>
    <p style={{ color: "#999999", marginBottom: "24px" }}>Start by choosing a room.</p>
    <ul>
      {allHints.rooms.map((room) => (
        <li
          key={room.name}
          style={{
            listStyle: "none"
          }}
        >
          <Link to={`/room/${room.name}`}>
            <p>{room.name}</p>
          </Link>
        </li>
      ))}
    </ul>
    <p style={{ color: "#999999", margin: "24px 0" }}>Finally, here's a complete walkthrough of the game.</p>
    <div style={{ display: "flex" }}>
      <iframe
        width="560"
        height="315"
        src={`https://www.youtube.com/embed/${allHints.videoId}`}
        frameBorder="0"
        title={"Complete Video Walkthrough"}
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        style={{ margin: "0 auto" }}
      />
    </div>
  </div>
);